import React, { useState, useRef, useEffect } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray, ErrorMessage } from "formik";
import DataTable from "react-data-table-component";
import * as Yup from "yup";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import DateTimeRangePicker from "@wojtekmaj/react-datetimerange-picker";
import "@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import API from "../../helpers/API";
import NotificationManager from "../../components/Common/NotificationManager";
import NewHeader from "../../Layouts/NewHeader";
import NewFooter from "../../Layouts/NewFooter";

import BreadCrumb from "../../components/Common/BreadCrumb";
import { Col, Row } from "reactstrap";
import apiAuth from "../../helpers/ApiAuth";

const customStyles = {
  table: {
    style: {
      minHeight: "170px",
      maxHeight: "100%",
      // overflowY: "scroll",
    },
  },

  headCells: {
    style: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      marginTop: "10px",
      fontSize: "16px !important",
    },
  },

  cells: {
    style: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      overflow: "none",
      minHeight: "47px",
      fontSize: "14px",
    },
  },
  headRow: {
    style: {
      background: "#ECECEC",
      fontWeight: "700",
      borderRadius: "10px 10px 0px 0px",
    },
  },
  rows: {
    style: {
      color: "#093564",
      border: "1px solid rgba(0, 0, 0, 0.10)",
      textTransform: "capitalize",
    },
  },

  pagination: {
    style: {
      color: "#000",
      backgroundColor: "#f3f3f9",
    },
  },
  noData: {
    background: "none",
    fontSize: "18px",
    color: "#888",
    textAlign: "center",
    padding: "20px",
  },
};

const DailyTransactions = () => {
  const [loading, setLoading] = useState(false);
  const [transactionsData, setTransactionsData] = useState(null);
  let end_date = new Date();
  let start_date = new Date();
  start_date.setDate(start_date.getDate() - 1);

  const history = useHistory();

  const formatDate = (dateString) => {
    return moment(dateString).format("YYYY-MM-DD");
  };

  const reGenerateToken = (transId) => {
    apiAuth
      .get(`api/Consumer/RegenerateToken?transactionId=${transId}`)
      .then((res) => {
        const { data } = res;
        if (!transactionsData) {
          transactionsData = [];
        }
        if (!data) {
          let prevData = [...transactionsData];

          let newData = prevData.map((item) => {
            if (item.transactionId === transId) {
              let obj = { ...item, ...data };
              return obj;
            }
            return item;
          });
          setTransactionsData([...newData]);
        }
      })
      .catch((err) => {
        console.log("error", err);

        NotificationManager.error(
          "",
          "Generate Token Error",
          3000,
          null,
          null,
          ""
        );
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        <NewHeader />
        {/* <div className="container" style={{ flex: "1" }}> */}
        <div
          className="mt-4 p-5"
          style={{
            background:
              "linear-gradient(180deg, rgba(23, 0, 0, 0.80) 28.15%, rgba(0, 11, 5, 0.80) 99.2%)",
            backdropFilter: "blur(30px)",
          }}
        >
          <h5 style={{ color: "#FFF", fontSize: "25px", fontWeight: "700" }}>
            Prepaid Electricity Recharge
          </h5>
          {localStorage.getItem("username") && <BreadCrumb />}
        </div>

        <div className="mx-1" style={{ flex: "1" }}>
          <Grid container>
            <Grid item lg={5} xs={12}>
              <div
                className="card px-5 py-5 my-3 mx-2 m-auto shadow-lg position-relative"
                style={{
                  top: "-45px",
                  borderRadius: "10px",
                  margin: "auto !important",
                }}
              >
                <Formik
                  initialValues={{
                    final_date: JSON.parse(
                      localStorage.getItem("final_date")
                    ) || [start_date, end_date],
                  }}
                  validationSchema={Yup.object({})}
                  onSubmit={(values) => {
                    setLoading(true);
                    localStorage.setItem(
                      "final_date",
                      JSON.stringify(values?.final_date)
                    );

                    const formattedStartDate = formatDate(
                      values?.final_date[0]
                    );
                    const formattedEndDate = formatDate(values?.final_date[1]);

                    apiAuth
                      .get(
                        `api/Consumer/TransactionsHistory?StartDate=${formattedStartDate}&EndDate=${formattedEndDate}`
                      )
                      .then((res) => {
                        const { data } = res;
                        const sortedDataDescending = data?.sort((a, b) => {
                          return new Date(b.timestamp) - new Date(a.timestamp);
                        });
                        setTransactionsData(sortedDataDescending);
                        setLoading(false);
                      })
                      .catch((err) => {
                        console.log("error", err);
                        setLoading(false);

                        NotificationManager.error(
                          "Transaction details",
                          "Transaction details Get Error",
                          3000,
                          null,
                          null,
                          ""
                        );
                      });
                  }}
                >
                  {({ values, errors, touched, setFieldValue }) => (
                    <Form className="av-tooltip tooltip-label-bottom">
                      <Row className="g-2">
                        <Col lg={6} className="">
                          <div className="mb-3">
                            <label
                              htmlFor="start_date"
                              className="form-label"
                              style={{
                                color: "#9e9e9e",
                                fontSize: "14px",
                              }}
                            >
                              Select Date Range
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <div>
                              <DateTimeRangePicker
                                format="dd/MM/yyyy"
                                className="form-control"
                                disableClock={true}
                                value={values["final_date"]}
                                onChange={(date) => {
                                  console.log("date", date);
                                  const start = moment(date[0]);
                                  const end = moment(date[1]);

                                  const difference = end.diff(start, "days");

                                  if (difference < 15) {
                                    setFieldValue("final_date", date);
                                    setTransactionsData(null);
                                  } else {
                                    NotificationManager.error(
                                      "",
                                      "Maximum you can select 15 days",
                                      3000,
                                      null,
                                      null,
                                      ""
                                    );
                                  }
                                }}
                              />
                            </div>
                            <ErrorMessage
                              name="final_date"
                              render={(msg) => (
                                <div className="text-danger">{msg}</div>
                              )}
                            />
                          </div>
                        </Col>
                      </Row>
                      <div className="mb-3">
                        {loading ? (
                          <div
                            className="spinner-border"
                            role="status"
                            style={{ color: "rgba(40, 40, 40, 0.8)" }}
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <div className="mt-4 mb-3">
                            <Button
                              className="btn my-2 w-30"
                              type="submit"
                              style={{
                                color: "white",
                                fontWeight: 500,
                                fontSize: "16px",
                                background:
                                  "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                borderRadius: "5px",
                                boxShadow:
                                  "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                textTransform: "capitalize",
                              }}
                            >
                              Search
                            </Button>
                          </div>
                        )}
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                {transactionsData && (
                  <div
                    className="mx-2 fs-16 fw-500"
                    style={{ borderRadius: "10px" }}
                  >
                    <DataTable
                      customStyles={customStyles}
                      columns={[
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Consumer No
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.meterNo}
                                // style={{
                                //   whiteSpace: "nowrap",
                                //   overflow: "hidden",
                                //   textOverflow: "ellipsis",
                                //   maxWidth: "200px",
                                // }}
                              >
                                {value?.consumerNo}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              meterno
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.meterNo}>{value?.meterNo}</div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Recharge Amount
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.rechargeAmount}
                                // style={{
                                //   whiteSpace: "nowrap",
                                //   textOverflow: "ellipsis",
                                //   maxWidth: "200px",
                                // }}
                              >
                                {value?.rechargeAmount}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Token No
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                                title={value?.tokenNo}
                                // style={{
                                //   maxWidth: "max-content",
                                // }}
                              >
                                {value?.tokenNo}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Transaction Id
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.transactionId}>
                                {value?.transactionId}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Status
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.transactionStatus}>
                                {value?.transactionStatus}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Payment Ack No
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.paymentAckNo}>
                                {value?.paymentAckNo}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Formatted Token
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.formattedToken}>
                                {value?.formattedToken}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Meter Make
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div title={value?.meterMake}>
                                {value?.meterMake}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Time
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div
                              // style={{
                              //   whiteSpace: "nowrap",
                              //   textOverflow: "ellipsis",
                              //   maxWidth: "200px",
                              // }}
                              >
                                {moment(value?.timestamp).format(
                                  "DD/MM/YYYY h:mm:ss A"
                                )}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                        {
                          name: (
                            <span className="font-weight-bold fs-13 text-uppercase">
                              Action
                            </span>
                          ),
                          selector: (row) => row,
                          cell: (value) => {
                            return (
                              <div>
                                {(value.transactionStatus ===
                                  "TRANSACTION_COMPLETED" ||
                                  value.transactionStatus ==
                                    "TRANSACTION INITIATED") &&
                                !value.formattedToken ? (
                                  <Button
                                    className="btn my-2 w-100"
                                    type="button"
                                    style={{
                                      color: "white",
                                      fontWeight: 500,
                                      fontSize: "16px",
                                      background:
                                        "linear-gradient(90deg, #433232 5.56%, #383735 95.49%)",
                                      borderRadius: "5px",
                                      boxShadow:
                                        "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)",
                                      textTransform: "capitalize",
                                    }}
                                    onClick={() => {
                                      reGenerateToken(value.transactionId);
                                    }}
                                  >
                                    Generate Token
                                  </Button>
                                ) : (
                                  <></>
                                )}
                              </div>
                            );
                          },
                          sortable: true,
                        },
                      ]}
                      data={transactionsData}
                      noDataComponent={
                        <div className="text-center fs-18 fw-600 m-auto mt-5">
                          There are no records to display!
                        </div>
                      }
                      pagination={transactionsData?.length > 10 ? true : false}
                      paginationPerPage={10}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
        {/* </div> */}
        <NewFooter />
      </div>
    </>
  );
};

export default DailyTransactions;
